import { AppConfig } from './app-config';
import type { WebviewRemoteJsonConfig } from './types';

declare global {
  interface Window {
    AviataApp?: {
      setABTestValue: (jsonABTestsConfig?: WebviewRemoteJsonConfig) => void;
      setConsumerToken?: (token: string) => void;
      setUserToken?: (token: string) => void;
      setRefreshToken?: (token: string) => void;
      setAppConfig?: (config: string) => void;
      goBack?: () => void;
    };
  }
}

export function registerAviataAppEvents() {
  window.AviataApp = {
    /**
     * @description the `setConsumerToken`, `setUserToken` and setRefreshToken methods are called when we make a call
     * to webview's `onCreated` method, so we need to define them all, even if we need to work with only one of them
     */
    setConsumerToken(token: string) {
      window.dispatchEvent(
        new CustomEvent('onTokenUpdated', {
          detail: { type: 'consumer-token', token },
        }),
      );
    },
    setUserToken(token: string) {
      window.dispatchEvent(
        new CustomEvent('onTokenUpdated', {
          detail: { type: 'user-token', token },
        }),
      );
    },
    setRefreshToken(token: string) {
      window.dispatchEvent(
        new CustomEvent('onTokenUpdated', {
          detail: { type: 'refresh-token', token },
        }),
      );
    },
    /**
     * @description To use AB tests an app should define setABTestValue method
     * before calling `Webview.requestABTestParameterValue`
     */
    setABTestValue() {
      throw new Error('ERR_WEBVIEW_UNIMPLEMENTED_METHOD: setABTestValue');
    },
    setAppConfig(config: string) {
      AppConfig.setConfig(config);
    },
    goBack() {
      window.dispatchEvent(new CustomEvent('onAppBackButtonClicked'));
    },
  };
}
